var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Viewable Impressions (50%) "),_c('info-tooltip',{attrs:{"content":"Creative for an ad appears on a user's screen and is more than 50% visible for at least 1 second."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }